/** Helpers UI — comunicación mock en Gestión Despacho (sin API real). */

export const DESPACHO_CHAT_PREP_NOTICE =
  "Vista operativa en preparación. En esta etapa los mensajes pueden ser demostrativos; la persistencia y notificaciones reales se implementarán en Fase 2.";

export const DESPACHO_TEAM_CHAT_SUBTITLE =
  "Chat interno del equipo — avisos generales y comunicación con auxiliares.";

export const DESPACHO_CLIENT_INBOX_TITLE = "Mensajes con clientes";

export const DESPACHO_CLIENT_INBOX_SUBTITLE =
  "Bandeja compartida de atención al cliente — continuidad del despacho aunque cambie el auxiliar asignado.";

export const DESPACHO_CLIENT_MODULE_REQUIRED_NOTE =
  "Para usarlo requiere contratar el módulo Gestión Despacho.";

/** @typedef {'chat_directo'|'enviar_seguimiento'|'solicitar_avance'|'recordar_pendiente'|'reasignar_pendiente'} DirectChatActionId */

export const DIRECT_CHAT_ACTIONS = [
  { id: "chat_directo", label: "Chat directo" },
  { id: "enviar_seguimiento", label: "Enviar seguimiento" },
  { id: "solicitar_avance", label: "Solicitar avance" },
  { id: "recordar_pendiente", label: "Recordar pendiente" },
  { id: "reasignar_pendiente", label: "Reasignar pendiente" },
];

const SUGGESTION_TEMPLATES = {
  chat_directo: "",
  enviar_seguimiento: "Necesito seguimiento de este cliente/tarea.",
  solicitar_avance: "Hola, ¿me puedes actualizar el avance de este pendiente?",
  recordar_pendiente: "Recordatorio: este pendiente sigue abierto.",
  reasignar_pendiente: "Por favor revisa si puedes tomar o reasignar este pendiente.",
  urgente: "Favor de revisar este pendiente urgente.",
};

/**
 * @param {DirectChatActionId} actionId
 * @param {{ titulo?: string, cliente?: string, auxiliarNombre?: string }} [context]
 */
export function buildDirectChatSuggestion(actionId, context = {}) {
  if (actionId === "chat_directo") {
    if (context.auxiliarNombre) {
      return `Hola ${context.auxiliarNombre}, ¿cómo va tu avance?`;
    }
    return "";
  }
  const base = SUGGESTION_TEMPLATES[actionId] || "";
  if (!base) return "";
  const parts = [base];
  if (context.titulo) {
    parts.push(`Pendiente: ${context.titulo}.`);
  }
  if (context.cliente) {
    parts.push(`Cliente: ${context.cliente}.`);
  }
  return parts.join(" ");
}

export const CLIENT_INBOX_STATUSES = [
  "Nuevo",
  "Pendiente",
  "En atención",
  "Esperando cliente",
  "Esperando despacho",
  "Resuelto",
  "Archivado",
];

export const CLIENT_INBOX_FILTERS = [
  { id: "todos", label: "Todos" },
  { id: "sin_responder", label: "Sin responder" },
  { id: "urgentes", label: "Urgentes" },
  { id: "asignados_a_mi", label: "Asignados a mí" },
  { id: "sin_asignar", label: "Sin asignar" },
  { id: "resueltos", label: "Resueltos" },
];

export const CLIENT_INBOX_QUICK_ACTIONS = [
  "Tomar conversación",
  "Reasignar",
  "Marcar como pendiente",
  "Marcar como resuelto",
  "Enviar recordatorio",
  "Solicitar documentos",
  "Solicitar estados de cuenta",
  "Agregar nota interna",
  "Abrir expediente del cliente",
  "Crear tarea desde mensaje",
];

/**
 * Filtra conversaciones mock según pestaña y rol simulado.
 * @param {object[]} rows
 * @param {string} filterId
 * @param {{ viewerRole?: string, viewerStaffId?: string }} [opts]
 */
export function filterClientInboxConversations(rows, filterId, opts = {}) {
  const role = String(opts.viewerRole || "owner").toLowerCase();
  const staffId = opts.viewerStaffId || "";
  let list = Array.isArray(rows) ? [...rows] : [];

  if (role === "auxiliar" && staffId) {
    list = list.filter(
      (row) =>
        !row.assignee_staff_id
        || row.assignee_staff_id === staffId
        || row.taken_by_staff_id === staffId
        || row.allow_general_inbox,
    );
  }

  switch (filterId) {
    case "sin_responder":
      return list.filter((r) => (r.unread_count || 0) > 0 && r.status !== "Resuelto" && r.status !== "Archivado");
    case "urgentes":
      return list.filter((r) => r.priority === "Urgente" || r.priority === "Crítico");
    case "asignados_a_mi":
      return list.filter((r) => staffId && r.assignee_staff_id === staffId);
    case "sin_asignar":
      return list.filter((r) => !r.assignee_staff_id && r.status !== "Resuelto" && r.status !== "Archivado");
    case "resueltos":
      return list.filter((r) => r.status === "Resuelto" || r.status === "Archivado");
    default:
      return list.filter((r) => r.status !== "Archivado");
  }
}

/** @param {string} status */
export function clientInboxStatusTone(status) {
  const st = String(status || "");
  if (st === "Nuevo") return "info";
  if (st === "Pendiente" || st === "Esperando despacho") return "warn";
  if (st === "En atención") return "neutral";
  if (st === "Esperando cliente") return "info";
  if (st === "Resuelto") return "neutral";
  if (st === "Archivado") return "neutral";
  return "neutral";
}
